import type { ListTableRowActionsContextValue } from "./list-table-row-actions.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "ListTableRowActionsContext",
  providerName: "ListTableRowActionsProvider",
};

export const ListTableRowActionsContext =
  createContext<ListTableRowActionsContextValue | null>(null);

export const useListTableRowActionsContext = () => {
  const contextValue = useContext(ListTableRowActionsContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
